
<template>
    <div>
        <md-card>
            <md-card-content>

                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <md-steppers md-sync-route :md-vertical="isVertical" md-linear>

                                <md-step :to="firstMajorStepPath" id="first" md-label="Details" md-description="Core Info">
                                    <div v-if="currentStep == 'details'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <company-details v-if="stepIndex === 0" :details="portfolio.details" entityDescription="the portfolio/client" 
                                                         unPublishEg="(e.g. SPV / no website)" descriptionLabel="Website Description">
                                        </company-details>

                                    </div>
                                </md-step>

                                <md-step :to="secondMajorStepPath" id="second" md-label="Address" md-description="Find Address">
                                    <div v-if="currentStep == 'address'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <company-address v-if="stepIndex === 1" :address="portfolio.address" :location="portfolio.location"
                                                         :name="portfolio.details.name"></company-address>
                                    </div>
                                </md-step>


                                <md-step :to="thirdMajorStepPath" id="third" md-label="Contact" md-description="Contact Details">
                                    <div v-if="currentStep == 'contact'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <company-contact v-if="stepIndex === 2" class="step_2" 
                                                         :contact="portfolio.contact" :organisationId="id"
                                                         :contactType="contactType"></company-contact>
                                    </div>
                                </md-step>


                                <md-step :to="fourthMajorStepPath" id="fourth" md-label="Logo" md-description="Upload logos">
                                    <div v-if="currentStep == 'files'" class="md-layout md-alignment-top-left">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                            <div class="md-layout-item md-medium-size-100 md-xlarge-size-50">
                                                <company-files v-if="stepIndex === 3" ref="filePondUpload" fileTypesTxt="logos" entityType="Portfolio"
                                                                extraInfoTxt=" i.e. image files (or pdfs, word docs, powerpoint docs containing logo images)"
                                                                acceptedFileTypes="image/jpeg, image/png, image/bmp, image/gif, image/svg+xml, image/tiff, image/webp, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation">
                                                </company-files>
                                            </div>
                                        </div>
                                </md-step>

                                <md-step :to="fifthMajorStepPath" id="fifth" md-label="Complete" md-description="Finalise">
                                    <div v-if="currentStep == 'complete'">
                                        <h1 class="page_title md-layout-item md-size-100">{{pageTitle}}</h1>

                                        <div class="md-layout-item md-small-size-100">
                                            <h3>Complete</h3>
                                            <p>Thanks for adding the details for <b>{{portfolio.details.name}}</b>, that's all done, please click Continue to <b>add a building</b></p>
                                        </div>
                                    </div>
                                </md-step>
                            </md-steppers>

                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>

                        <div class="stepper-buttons-wrap md-layout md-alignment-space-between">
                            <div class="md-layout-item md-alignment-top-right">
                                <md-button :disabled="disableBtns" v-if="!isStart" :to="previousUrl" class="md-raised md-primary">Back</md-button>
                            </div>
                            <div class="md-layout-item md-alignment-top-right md-layout">
                                <md-button :disabled="disableBtns" v-if="!isEnd" @click="nextClick" class="md-raised md-primary">Next</md-button>
                                <md-button :disabled="disableBtns" v-else class="md-success" @click="continueClick">Continue</md-button>
                            </div>
                        </div>

                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import { extend } from "vee-validate";
    import { required, email, min } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import stepsList from "./wizardSteps";
    import Api from '@/ts/UvApiService';
    import { PortfolioStatus } from '@/ts/portfolioSpec';
    import { ContactTypes } from '@/ts/ContactComponents';

    import CompanyDetails from "@/components/Company/Details.vue";
    import CompanyAddress from "@/components/Company/Address.vue";
    import CompanyContact from "@/components/Company/Contact.vue";
    import CompanyFiles from "@/components/Company/Files.vue";

    export default {
        components: {
            FadeTransition
            , Loader
            , CompanyDetails
            , CompanyAddress
            , CompanyContact
            , CompanyFiles
        },
        data() {
            return {
                loading: true,
                id: 0,
                portfolio: null,
                isVertical: false,
                currentRoutePath: null,
                steps: stepsList,
                stepIndex: 0,
                disableBtns: false
            }
        },
        methods: {
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this portfolio`;
                this.$notify({
                    timeout: 3500,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            async continueClick() {
                if (this.isSaved) await this.done();
                else await this.save();
            },
            async save() {
                var res = await Api.portfolios.save(this.id);
                if (res.success === true) {
                    this.portfolio.status = PortfolioStatus.saved;
                    this.done();
                }
                else {
                    this.showServerFailMessage(res, "saving");
                }
            },
            done() {
                this.$router.push(`/portfolios/${this.id}/buildings/new`);//.catch(err => { }); //TODO:TD ehhh? whats going on here 
                let msg, msgType, iconType = "";

                if (this.isSaved) {
                    msg = `Your details for <b>${this.portfolio.details.name}</b> were saved, please <b>add a building</b>`;
                    msgType = NotyTypes[NotyTypes.success];
                    iconType = "thumb_up";
                }

                if (this.isSaved) {
                    setTimeout(() => {
                        this.$notify({
                            timeout: 8500,
                            message: msg,
                            icon: iconType,
                            horizontalAlign: "center",
                            verticalAlign: "top",
                            type: msgType,
                            animate: {
                                enter: 'animated fadeInDown',
                                exit: 'animated fadeOutUp'
                            }
                        });
                    }, 600);
                }
            },
            async saveStep() {
                this.disableBtns = true;
                if (this.currentPathInfo.path === "/portfolios/:portfolioId/files") {
                    this.portfolio.files.list = this.$refs.filePondUpload.getFiles();
                }
                var objData = Help.objReferenceFromString(this.portfolio, this.currentDataPath);
                var res = await Api.portfolios.upsertPortfolio(this.id, objData, this.currentDataPath, this.currentStepForDto);
                this.id = res.id;
                var relevantJson = Help.objReferenceFromString(res.json, this.currentDataPath);
                Help.objReferenceFromString(this.portfolio, this.currentDataPath, relevantJson);
                this.disableBtns = false;
            },
            async runCustomValidation() {
                var result = { valid: true };
                if (this.currentPathInfo.path === "/portfolios/:portfolioId/files") {
                    result = this.$refs.filePondUpload.validateFilePondStatus();
                }
                return result;
            },
            async nextClick() {
                var result = await this.runCustomValidation();
                if (result.valid) {
                    await this.validatePageSaveOrAlert();
                }
                else {
                    this.notifyErrors(result.errors);
                }
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";

                errorsArray.forEach((e) => {
                    if (e.length > 0) {
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });

                this.$notify({
                    timeout: 2500,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            async validatePageSaveOrAlert() {
                this.$refs.valObserver.validate().then(async success => {

                    if (!success) {

                        setTimeout(() => { //TODO: update vee validate timeout here is to ensure errors are there and correct https://github.com/logaretm/vee-validate/issues/2248#issuecomment-578229806
                            this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                        }, 100);

                        return;
                    }
                    else {
                        await this.saveStep();
                        this.$router.push(this.nextUrl);
                    }
                });
            },
            getUrlFromPattern(urlFormat) {
                return urlFormat.replace(":portfolioId", this.id);
            },
            getPatternFromUrl(url) {
                return url.replace(this.id, ":portfolioId");
            }
        },
        computed: {
            contactType() {
                return ContactTypes.portfolio;
            },
            isSaved() {
                return this.portfolio.status === PortfolioStatus.saved;
            },
            pageTitle() {
                var respVal = "New Portfolio";
                if (this.isEditMode) {
                    respVal = this.portfolio.details.name;
                }
                return respVal;
            },
            firstMajorStepPath() {
                if (this.isEditMode) {
                    return `/portfolios/${this.id}/details`;
                }
                else {
                    return `/portfolios/new`;
                }
            },
            secondMajorStepPath() {
                return `/portfolios/${this.id}/address`;
            },
            thirdMajorStepPath() {
                return `/portfolios/${this.id}/contact`;
            },
            fourthMajorStepPath() {
                return `/portfolios/${this.id}/files`;
            },
            fifthMajorStepPath() {
                return `/portfolios/${this.id}/complete`;
            },
            currentPathInfo() {
                return this.steps[this.stepIndex];
            },
            currentStep() {
                return this.currentPathInfo.step;
            },
            currentDataPath() {
                return this.currentPathInfo.dataPath;
            },
            isStart: function () { return this.currentPathInfo.start ?? false; },
            isEnd: function () { return this.currentPathInfo.end ?? false; },
            nextUrl: function () {
                var respVal = null;
                if (!this.isEnd) {
                    respVal = this.steps[this.stepIndex + 1].path;
                    respVal = this.getUrlFromPattern(respVal);
                }
                return respVal;
            },
            previousUrl: function () {
                var respVal = null;
                if (!this.isStart) {
                    respVal = this.steps[this.stepIndex - 1].path;
                    respVal = this.getUrlFromPattern(respVal);
                }
                return respVal;
            },
            isEditMode() {
                return Help.isGoodNumber(this.id) && this.id > 0;
            },
            currentStepForDto() {
                var fullPath = this.currentPathInfo.path;
                return fullPath.replace("/portfolios/:portfolioId", "");
            }
        },
        async created() {
            if (!Help.isNullOrUndef(this.$route.params.portfolioId)) {
                this.id = parseInt(this.$route.params.portfolioId);
                this.portfolio = await Api.portfolios.getPortfolio(this.$route.params.portfolioId);
                this.loading = false;
            }
            else {
                this.portfolio = await Api.portfolios.getEmptyPortfolio();//TODO:TD do on server??? customerId
                this.loading = false;
            }
        },
        async mounted() {
            this.$nextTick().then(() => {
                this.currentRoutePath = this.$route.path;
            });
        },
        watch: {
            '$route'() {
                this.$nextTick(function () {
                    this.currentRoutePath = this.$route.path;
                });
            },
            currentRoutePath(v) {
                if (this.isEditMode) {
                    var path = this.getPatternFromUrl(v);
                    this.stepIndex = this.steps.findIndex(function (item) { return item.path === path; });
                }
                else {
                    this.stepIndex = 0;
                }
            }
        }
    }
</script>
<style lang="scss">
</style>

<!--maybe should have used cref https://vuejs.org/v2/guide/components.html#Dynamic-Components-->